export const CardKind = {
  Credit: 'Credit',
  Debit: 'Debit',
} as const;
export type CardKind = (typeof CardKind)[keyof typeof CardKind];
